import { render, staticRenderFns } from "./datasource-electronic-archive-form.vue?vue&type=template&id=bb28c1c6"
import script from "./datasource-electronic-archive-form.vue?vue&type=script&lang=js"
export * from "./datasource-electronic-archive-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports